// extracted by mini-css-extract-plugin
module.exports = {"main":"ResourceCard_main__Hs_87","search-fade-in":"ResourceCard_search-fade-in__GGIfn"};